import { IPropertyBlockBrand } from "../interfaces/property/property-block-brand.model.interface";
import { IProductCategory } from "../interfaces/product/product-category.model.interface";
import { ProductCategory } from "@/models/product/product-category.model";

export class PropertyBlockBrand implements IPropertyBlockBrand {
    public propertyId: number;
    public productCategoryId: number;
    public brandId: number;
    public brandName: string;
    public blockOnBrand: boolean;
    public blockConquest: boolean;
    public productCategory: IProductCategory;

    constructor() {
        this.propertyId = 0;
        this.productCategoryId = 0;
        this.brandId = 0;
        this.brandName = "";
        this.blockOnBrand = true;
        this.blockConquest = true;
        this.productCategory = new ProductCategory();
    }
}
